import { IconButton } from "@fluentui/react";
import { ExperimentType } from "../../Types";
import { UNARCHIVE_KEY } from "../../Shared/shared.consts";

export const renderUnArchiveAction = (
  item: ExperimentType,
  handleUnArchive: (item: ExperimentType) => void,
  hasAdoAccess: boolean | undefined,
) => {
  return (
    <IconButton
      iconProps={{ iconName: "FabricOpenFolderHorizontal" }}
      title="Unarchive Experiment"
      ariaLabel="Unarchive Experiment"
      onClick={() => handleUnArchive(item)}
      disabled={item?.pr?.title?.includes(UNARCHIVE_KEY) || !hasAdoAccess}
      style={{
        background: "unset",
      }}
    />
  );
};
